import React, { useEffect, useState } from "react";
import { setKey, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import PaymentConfirm from "./PaymentConfirm";
import Checkout from "./Checkout";
import CountriesDropdown from "./CountriesDropdown";
import DeliveryAddress from "./DeliveryAddress";
import keys from "../store/keys";

function Cart({ session, setKey, setStringifiedKey, ...props }) {

	return (
		<div className="container">
			<div className="row mt-20">
				<div className="col-8" style={{paddingRight: 50}}>
					<Checkout />
					<DeliveryAddress onChange={obj => setStringifiedKey(keys.deliveryAddress, obj)} showButton={false} handleSubmit={null} />
				</div>
				<div className="col-4">
					<PaymentConfirm />
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
    setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
